import { Button } from '@wartek-id/button-v1'

import type { FC } from 'react'

type Props = {
  continueLabel?: string
  continueDisabled?: boolean
  continueOnClick?: () => void

  cancelLabel?: string
  cancelDisabled?: boolean
  cancelOnClick?: () => void
}

export const DialogButtons: FC<Props> = ({
  continueLabel = 'Lanjut',
  continueDisabled = false,
  continueOnClick = () => {},

  cancelLabel = 'Kembali',
  cancelDisabled = false,
  cancelOnClick = () => {},
}) => {
  return (
    <div className="flex gap-3">
      <Button
        size="lg"
        color="white"
        disabled={cancelDisabled}
        onClick={cancelOnClick}
      >
        {cancelLabel}
      </Button>

      <Button
        size="lg"
        color="blue"
        disabled={continueDisabled}
        onClick={continueOnClick}
      >
        {continueLabel}
      </Button>
    </div>
  )
}
